export function expander() {
    [].slice.call(document.querySelectorAll('.expander')).map((el)=>{
        const expand = el.querySelector('a.expander__expand')
        const collapse = el.querySelector('a.expander__collapse')
        const body = el.querySelector('div.expander__body')

        expand.addEventListener('click',(e)=>{
            e.preventDefault()
            body.classList.add('show')
            body.style.display = 'block'
            expand.style.display = 'none'
            collapse.style.display = 'block'
        })
        collapse.addEventListener('click',(e)=>{
            e.preventDefault()
            body.classList.remove('show')
            body.style.display = 'none'
            expand.style.display = 'block'
            collapse.style.display = 'none'
        })
    })
}
